/**
 * Layout for /admin/config/* — the route's only h1 ("Configuration") with the
 * config pill tab row beneath it, + an <Outlet/> for the chosen config page.
 * Config pages open with an h2 (ConfigSectionHeader), never their own h1.
 *
 * OWNS its page container: /admin/config is a TOP-LEVEL sidebar route (pulled
 * out of AdminLayout's nesting June 2026), so without this the body would sit
 * flush against the sidebar with no padding.
 */

import { Outlet } from 'react-router-dom';
import { TabRow, type SectionTab } from '../../components/SectionTabs';
import { PageHeader } from '../../components/PageHeader';

const CONFIG_TABS: SectionTab[] = [
  { to: '/admin/config', label: 'Overview', end: true },
  { to: '/admin/config/hub', label: 'Hub & access' },
  { to: '/admin/config/expenses', label: 'Expense Tool' },
  { to: '/admin/config/invoices', label: 'Invoice Submission' },
  { to: '/admin/config/credit-cards', label: 'Credit Card Submission' },
  { to: '/admin/config/absence', label: 'Absence' },
  { to: '/admin/config/holidays', label: 'Holidays' },
  { to: '/admin/config/documents', label: 'Document Vault' },
  { to: '/admin/config/onboarding', label: 'On/Offboarding' },
  { to: '/admin/config/drivers', label: 'DAAily Drivers' },
  { to: '/admin/config/mutations', label: 'Monthly Mutations' },
  { to: '/admin/config/email', label: 'Email senders' },
  {
    to: '/admin/config/access',
    label: 'Access & Profiles',
    match: ['/admin/config/access', '/admin/config/profile'],
  },
  { to: '/admin/config/tiles', label: 'Hub tiles' },
];

export function ConfigLayout() {
  return (
    <main className="w-full max-w-page px-4 md:px-8 pt-6 pb-10 space-y-6">
      <PageHeader title="Configuration">
        <TabRow tabs={CONFIG_TABS} wrap />
      </PageHeader>
      <Outlet />
    </main>
  );
}
